export default [
    {
        path: 'expense_reimbursement',
        name: 'm_expense_reimbursement',
        meta: {
            templateManage: {
                workType: 11,
                print: 'b_expense_reimbursement_printtemplate',
                export: 'b_expense_reimbursement_exporttemplate'
            },
            appView: {
                viewId: '10011',
                auth: 'b_expense_reimbursement_viewmanage'
            }
        },
        component: () => import('@/pages/finance/expense_reimbursement_list.vue')
    }
];
